import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui';

const styles = (theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: '100%',
    padding: '10px 20px',
    fontSize: '0.8rem',
    fontFamily: 'Helvetica',
  },
  finishedButton: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: '100%',
    padding: '10px 20px',
    fontSize: '0.8rem',
    fontFamily: 'Helvetica',
  },
  disabledButton: {
    backgroundColor: '#cecece',
    color: 'white',
    width: '100%',
    padding: '10px 20px',
    fontSize: '0.8rem',
    fontFamily: 'Helvetica',
    cursor: 'not-allowed',
  },
});

const NextButton = ({
  nextStepTitle,
  onClick,
  disabled,
  activeStep,
  classes,
}) => {
  const classnames = () => {
    if (activeStep === 4) {
      return classes.finishedButton;
    }

    if (disabled) {
      return classes.disabledButton;
    }

    return classes.button;
  };

  return (
    <button className={classnames()} onClick={onClick} disabled={disabled}>
      {nextStepTitle}
    </button>
  );
};

NextButton.propTypes = {
  disabled: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  nextStepTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
};

NextButton.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(NextButton);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/NextButton.js